import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DashboardLayout from "./pages/Codes/DashboardLayout";
import EventsPage from "./pages/Codes/EventsPage";
import Community, { MyPostsPage } from "./pages/Codes/Community";
import ScheduleMeeting from "./pages/Codes/ScheduleMeeting";
import MeetingGenie from "./pages/Codes/MeetingGenie";
import SharkTank from "./pages/Codes/SharkTank";
import ImageOptimizer from "./pages/Codes/ImageOptimizer";
import Advertisement, { MyPostsPage as AdvertisementMyPostsPage } from "./pages/Codes/Addvertisment";
import BlogsPage, { BlogsCategoryPage, BlogArticlePage, BlogCreatePage } from "./pages/Codes/BlogsPage";

/* Lightweight placeholder shown for the Dashboard home and for sidebar links
   whose pages have not been built yet. Rendered INSIDE the DashboardLayout
   content area, so the shell stays intact. */
function PlaceholderPage({ title, message }) {
  return (
    <section className="Dashboard-home">
      <h1 className="Dashboard-home-title">{title}</h1>
      <p className="Dashboard-home-text">{message}</p>
    </section>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<DashboardLayout />}>
          <Route
            path="/"
            element={
              <PlaceholderPage
                title="Dashboard"
                message="Welcome to your IHN business dashboard. Your overview will appear here."
              />
            }
          />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/community" element={<Community />} />
          <Route path="/community/my-posts/:tab?" element={<MyPostsPage />} />
          <Route path="/schedule-meeting" element={<ScheduleMeeting />} />
          <Route path="/meeting-genie" element={<MeetingGenie />} />
          <Route path="/shark-tank" element={<SharkTank />} />
          <Route path="/image-optimizer" element={<ImageOptimizer />} />
          <Route path="/advertisements" element={<Advertisement />} />
          <Route path="/advertisement/my-posts/:tab?" element={<AdvertisementMyPostsPage />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/blogs/:category" element={<BlogsCategoryPage />} />
          <Route path="/blog/create" element={<BlogCreatePage />} />
          <Route path="/blog/:slug" element={<BlogArticlePage />} />
          <Route
            path="*"
            element={
              <PlaceholderPage
                title="Coming soon"
                message="This section is part of the IHN roadmap and will be available soon."
              />
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
